(function () {
    'use strict';

    var CheckBuyBanner = {
        bindings: {
            onCloseBanner: '&'
        },
        controller: CheckBuyCtrl,
        templateUrl: 'check-buy-banner.component.html'
    };

    CheckBuyCtrl.$inject = ['timestampSvc', '$scope', 'itxAkamaiSvc'];

    function CheckBuyCtrl(timestampSvc, $scope, itxAkamaiSvc) {
        let _this = this;
        _this.$onInit = function () {
            _this.banner = 'buy';
            _this.from = inditex.iStoreJSON.countryName;

            const cookieName = 'registered_user_cookie';
            const cookie = inditex.readCookie(cookieName);

            if (cookie != null) {
                let cookieData = JSON.parse(cookie);
                if (inditex.iUserJSON.email) {
                    joyr.rest.xRestGetOrder(cookieData.orderId).then((orderData) => {
                        _this.order = orderData;
                        if (_this.order.statusText) {
                            _this.statusText = _this.order.statusText;
                        }
                        if (
                            _this.order.items.length > 0 &&
                            _this.order.items[0].colors.length > 0 &&
                            _this.order.items[0].colors[0].image &&
                            _this.order.items[0].colors[0].image.url
                        ) {
                            let imageURL = _this.order.items[0].colors[0].image.url;
                            _this.url = `${inditex.iStoreJSON.details.imageBaseUrl}${imageURL}_5_1_16.jpg?t=${timestampSvc.getTs()}`;
                            _this.image = itxAkamaiSvc.useAkamaiImage(_this.url, 30);
                        }
                        if (_this.order.orderTracking && Object.keys(_this.order.orderTracking).length > 0) {
                            let orderTrackingId = Object.keys(_this.order.orderTracking)[0];
                            _this.deliveryDate = _this.order.orderTracking[orderTrackingId].fechaEstimada.substring(0, 10);
                        }
                        _this.addClassAnimation();
                        setTimeout(function () {
                            _this.close();
                        }, 8000);
                        $scope.$digest();
                    });
                }
            }
        };

        _this.redirect = function () {
            let location = joyr.utils.getCommonPageUrl('ItxMyAccountPage', false, false);
            window.location.href = location + '#/orders-type/';
            _this.close();
        };

        _this.close = function () {
            _this.addClassAnimation();
            setTimeout(function () {
                _this.onCloseBanner({ banner: _this.banner, hideBannerNextTime: true });
            }, 200);
        };

        _this.addClassAnimation = function () {
            let bannerElement = angular.element(document.querySelector('.md-banners-center'));
            if (bannerElement) {
                setTimeout(function () {
                    bannerElement.toggleClass('has-banner-animation');
                }, 100);
            }
        };
    }

    angular.module('itxApp.common').component('itxCheckBuyBanner', CheckBuyBanner);
})();
